// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__pxete","content":"default_content__-hAyY","header":"default_header__GWRo-","section":"default_section__sWKF2"};